import React, { FC } from 'react';
import DetailPage from 'src/components/DetailPage';

const Furniture: FC<FurnitureDto> = ({ Title, PreviewImage }) => {
  return <DetailPage images={[PreviewImage]} slides={[]} title={Title} />;
};

export default Furniture;
